var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-modal"},[_c('p',{staticClass:"title"},[_c('b',[_vm._v("Keyword:")]),_vm._v(" "+_vm._s(_vm.keyword.kw))]),_vm._v(" "),_c('keyword-chart',{attrs:{"close-handler":function () {
        _vm.toggleShowSingleChart(_vm.keyword);
        _vm.close();
      },"keywords":[_vm.keyword]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }